import _typeof from "@babel/runtime/helpers/typeof";
import React from 'react';
import moment from 'moment';
import URL from 'url-parse';
import { Tooltip } from 'components';
import { Video } from 'components';
import * as styles from './PostPlatformPreview.scss';

function LinkedinPreview(props) {
  var account = props.account,
      images = props.images,
      _props$isCompany = props.isCompany,
      isCompany = _props$isCompany === void 0 ? false : _props$isCompany,
      link = props.link,
      linkTitle = props.linkTitle,
      message = props.message,
      postDate = props.postDate,
      postType = props.postType,
      videos = props.videos;

  var timeSince = function timeSince(date) {
    if (_typeof(date) !== 'object') {
      date = new Date(date);
    }

    if (moment(date).isBefore(moment())) {
      return 'now';
    }

    return moment(date).fromNow();
  };

  var m = message && message.replace(/\s+/g, '') ? /*#__PURE__*/React.createElement("span", null, message) : /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", null, "Type a message to see the preview here."));
  var accountInfo = {
    profileImage: false,
    profileName: /*#__PURE__*/React.createElement("span", null, "Username", ' ', /*#__PURE__*/React.createElement(Tooltip, {
      p: true,
      name: "missing_linkedin_account",
      message: "You do not have a LinkedIn".concat(isCompany ? ' company ' : ' ', "account connected.")
    }))
  };
  var imageUrl = images && images.length > 0 ? images[0] : '';
  var source = link || '';

  if (source) {
    var url = new URL(source, {});
    source = url.hostname;
  }

  if (account) {
    accountInfo.profileImage = account.avatarImageUrl;
    accountInfo.profileName = account.username;
  }

  var linkSection = link && postType === 'linkPost' ? /*#__PURE__*/React.createElement("div", {
    className: styles.li_link_wrap,
    style: !imageUrl ? {
      height: 'auto'
    } : {}
  }, imageUrl && /*#__PURE__*/React.createElement("div", {
    className: styles.li_link_image_wrap
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.li_link_image,
    style: {
      backgroundImage: "url(".concat(imageUrl, ")")
    }
  })), /*#__PURE__*/React.createElement("article", {
    className: styles.li_link_title_wrap
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.li_link_title
  }, linkTitle), /*#__PURE__*/React.createElement("a", {
    href: link,
    target: "_blank",
    style: {
      textDecoration: 'none'
    }
  }, /*#__PURE__*/React.createElement("h3", {
    className: styles.li_link_source
  }, source)))) : null;
  var imageSectionImageList = images && images.length > 0 ? images : [];
  var imageSection = postType === 'imagePost' && !link && imageSectionImageList && imageSectionImageList.length ? /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 10,
      marginBottom: 20,
      height: imageSectionImageList.length === 2 ? 552 : imageSectionImageList.length > 2 ? 425 : 'auto'
    }
  }, imageSectionImageList.map(function (img, idx) {
    return /*#__PURE__*/React.createElement("img", {
      style: {
        width: idx === 0 && imageSectionImageList.length > 2 ? '100%' : imageSectionImageList.length > 2 ? "".concat(1 / (imageSectionImageList.length - 1) * 100, "%") : "".concat(1 / imageSectionImageList.length * 100, "%"),
        height: imageSectionImageList.length > 2 ? idx === 0 ? '60%' : '40%' : '100%',
        objectFit: 'cover',
        border: '1px solid white'
      },
      src: img
    });
  })) : null;
  var videoSection = null;

  if (postType === 'videoPost' && false) {
    // We cannot post videos via API on LinkedIn - render warning below
    videoSection = videos && videos.length > 0 ? videos[0].indexOf('blarplesnurf') === -1 || videos[0].indexOf('blarplesnurf-staging') === -1 ? /*#__PURE__*/React.createElement("div", {
      style: {
        padding: 10
      }
    }, /*#__PURE__*/React.createElement(Video, {
      src: videos[0],
      style: {
        width: '100%',
        border: '1px solid rgba(0, 0, 0, 0.11)'
      },
      autoPlay: true,
      loop: true,
      controls: true,
      muted: true
    })) : /*#__PURE__*/React.createElement("div", {
      style: {
        textAlign: 'center',
        padding: 10
      }
    }, /*#__PURE__*/React.createElement("p", null, "Your video is being processed. One moment..."), /*#__PURE__*/React.createElement("i", {
      className: "fa fa-spinner fa-spin"
    })) : null;
  } else if (postType === 'videoPost') {
    videoSection = /*#__PURE__*/React.createElement("div", {
      style: {
        textAlign: 'center',
        padding: 10
      }
    }, /*#__PURE__*/React.createElement("p", {
      style: {
        color: '#ffa100',
        fontStyle: 'italic'
      }
    }, "Posts containing videos cannot be automatically posted to LinkedIn. A link to this video will be used instead."));
  }

  return /*#__PURE__*/React.createElement("section", {
    className: styles.liFixedFull
  }, /*#__PURE__*/React.createElement("article", {
    className: styles.liUpdate
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.liScroll
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.liFeedPostMeta
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.liFeedPostMetaActor
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.liProfileImageWrap,
    style: isCompany ? {
      borderRadius: 0
    } : null
  }, !isCompany ? /*#__PURE__*/React.createElement("img", {
    src: accountInfo.profileImage ? accountInfo.profileImage : 'https://s3.amazonaws.com/likeabucket/user_upload/232/h-q1C_CMb.jpeg',
    className: styles.liAvatar
  }) : /*#__PURE__*/React.createElement("div", {
    className: styles.liCompanyAvatar,
    style: {
      backgroundImage: "url(".concat(accountInfo.profileImage ? accountInfo.profileImage : 'https://s3.amazonaws.com/likeabucket/user_upload/232/qCWmHP1bt.png', ")")
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.liFeedPostMetaProfileWrap
  }, /*#__PURE__*/React.createElement("h3", {
    className: styles.liFeedPostMetaHeader
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.liFeedPostMetaName
  }, accountInfo.profileName), /*#__PURE__*/React.createElement("time", {
    className: styles.liFeedPostMetaTimestamp
  }, postDate ? timeSince(postDate.toDate()) : '')))), /*#__PURE__*/React.createElement("div", {
    className: styles.liMessageWrap
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.liMainContent
  }, /*#__PURE__*/React.createElement("span", {
    id: "test-li-message"
  }, m))), linkSection, imageSection, videoSection, link && /*#__PURE__*/React.createElement("div", {
    className: styles.liFeedSocialCounts
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.liFeedSocialActionBar
  }, /*#__PURE__*/React.createElement("img", {
    style: {
      width: 250
    },
    src: "https://s3.amazonaws.com/likeabucket/user_upload/232/bYP2nOcMH.png"
  })))));
}

export default LinkedinPreview;